import { Button, FormControl, InputAdornment, MenuItem, Select } from '@material-ui/core';
import { useEffect, useState } from 'react';
import en from '../../../../lang/en-us';
import { CustomRadio } from '../../../../lib/CustomRadio';
import TextInput from '../../../../lib/TextField';
import AddNominee from '../UpdateNominee/addNominee';
import * as yup from 'yup';
import { SubmitButton, SubmitButtonWithLoader } from '../../../../lib/Button';
import { NoteModals } from '../../../../lib/NoteModals';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { connect } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import {
    getDate,
    getDateString,
    UPDATE_NOMINEE,
    OTP_ACTIONS,
    panRegex,
    _minDateForCalender,
} from '../../../../utils/constants';
import { getNameIndex } from '../CorrectionFolios/correction-folios-selection';
import { ActionHeader, FaqLink } from '..';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
const {
    dashboard,
    dbCommercial,
    signUp: { form },
    common,
} = en;

export interface InitialState {
    relation: string;
    name: string;
    dob: Date | string;
    share: number | null;
    gender: string;
    pan: string;
    address1: string;
    address2: string;
    address3?: string;
    pincode: number | string;
    city: string;
    state: string;
    country: string;
    guardianName: string;
    guardianPan: string;
    guardianAddress: string;
    guardianDob: Date | string;
    isEditable?: boolean;
    isNewlyAdded?: boolean;
    showDetails?: boolean;
    editShare?: boolean;
    id?: string;
    isEdited?: boolean;
}
export interface NOMINEEINFO extends InitialState {
    initialState?: InitialState;
}
export interface RELATIONS {
    label: string;
    value: string;
}
export const relationShips = [
    {
        label: 'Mother',
        value: 'mother',
    },
    {
        label: 'Son',
        value: 'son',
    },
    {
        label: 'Daughter',
        value: 'daughter',
    },
    {
        label: 'Father',
        value: 'father',
    },
    {
        label: 'Spouse',
        value: 'spouse',
    },
    {
        label: 'Others',
        value: 'others',
    },
];

export const initialValues: NOMINEEINFO = {
    relation: '',
    name: '',
    dob: '',
    share: null,
    gender: '',
    pan: '',
    address1: '',
    address2: '',
    pincode: '',
    city: '',
    state: '',
    country: '',
    guardianName: '',
    guardianPan: '',
    guardianAddress: '',
    guardianDob: '',
};

export const validationSchemaNominee = yup.object({
    relation: yup.string().required('Relation is required'),
    name: yup
        .string()
        .required('Name is required')
        .test('len', 'Name is Required', (val) => val?.trim().length !== 0),
    gender: yup.string().required('Gender is required'),
    dob: yup.date().required("Date of Birth is required"),
    pan: yup.string().matches(panRegex, form.pan.validations.individualPan),
    address1: yup
        .string()
        .notRequired()
        .test('len', common.spaceNotAllowed, (val) => val?.trim().length !== 0),
    address2: yup
        .string()
        .notRequired()
        .test('len', common.spaceNotAllowed, (val) => val?.trim().length !== 0),
    city: yup
        .string()
        .notRequired()
        .test('len', common.spaceNotAllowed, (val) => val?.trim().length !== 0)
        .max(50, common.cityMaxLength),
    state: yup
        .string()
        .notRequired()
        .test('len', common.spaceNotAllowed, (val) => val?.trim().length !== 0)
        .max(50, common.stateMaxLength),
    pincode: yup.string().length(6, 'Pincode should be of 6 digits'),
    guardianPan: yup.string().notRequired().matches(panRegex, form.pan.validations.individualPan),
    // guardianDob: yup.string().required('Select date of birth'),
});

function MinorUpdateNomineeEdit(props: any) {
    const { nomineesData = {} } = props.location.state || {};
    const { nominees: data = [], investorName = '' } = nomineesData;
    const [nominees, setNominees] = useState<NOMINEEINFO[]>([]);
    const [noNomineeFlag, setNoNomineeFlag] = useState(false);
    const [show, setShow] = useState<boolean>(false);
    const [deleteIndex, setDeleteIndex] = useState<any>('');
    const [loading, setLoading] = useState(false);
    const [showShareModal, setShowShareModal] = useState<{ show: boolean; text: string }>({
        show: false,
        text: '',
    });

    // useEffect(() => {
    //     if (!Object.keys(nomineesData).length) {
    //         props.history.push('/');
    //         return;
    //     }
    // }, []);

    useEffect(() => {
        setNominees(
            !!data.length
                ? data.slice(0, 3).map((_ele: any) => {
                      let nomineeState = {
                          relation: ['mother', 'son', 'daughter', 'father', 'spouse'].includes(
                              _ele?.relation?.toLowerCase(),
                          )
                              ? _ele.relation?.toLowerCase()
                              : _ele.relation?.toLowerCase()
                              ? 'others'
                              : '',
                          name: _ele.name || '',
                          dob: getDate(_ele.dob),
                          share: _ele.percent,
                          pan: _ele.pan,
                          gender: _ele.gender.toLowerCase(),
                          address1: _ele.address.line1,
                          address2: _ele.address.line2,
                          ..._ele.address,
                          guardianName: _ele.guardian.name,
                          guardianPan: _ele.guardian.pan,
                          guardianAddress: _ele.guardian.address || '',
                          guardianDob: _ele.guardian.dob || '',
                          isEditable: false,
                          showDetails: false,
                          editShare: false,
                          isNewlyAdded: false,
                          id: _ele.id,
                          isEdited: false,
                      };
                      return { ...nomineeState, initialState: nomineeState };
                  })
                : [
                      {
                          ...initialValues,
                          isEditable: false,
                          showDetails: false,
                          editShare: false,
                          isNewlyAdded: true,
                          isEdited: false,
                      },
                  ],
        );
    }, []);

    const handleAddNomiee = () => {
        setNominees([...nominees, { ...initialValues, isEditable: true, isNewlyAdded: true }]);
    };

    const cancelFormSubmission = (index: number, id: string) => {
        const nominee = nominees[index];
        const { isNewlyAdded } = nominee;
        if (isNewlyAdded) {
            // if (nominees.length === 1 && index === 0) {
            //     props.history.goBack();
            // }
            setNominees(nominees.filter((_ele: NOMINEEINFO, ind: number) => index !== ind));
            return;
        }
        setNominees((prevState: NOMINEEINFO[]) => {
            const nominees = [...prevState];
            const nominee = nominees[index];
            nominees[index] = { ...nominee, ...nominee.initialState, isEditable: false };
            return nominees;
        });
    };

    const resetForm = (index: number) => {
        const nominee = [...nominees];
        nominee[index] = { ...initialValues, isEditable: true };
        setNominees(nominee);
    };

    const handleNomineeChange = (key: any, value: any, index: any) => {
        const nominee: any[] = [...nominees];
        nominee[index][key] = value;
        setNominees(nominee);
    };

    const handleDeleteNominee = (ind: number) => {
        const updatedNominees = nominees.map((_ele: NOMINEEINFO) => ({
            ..._ele,
            isEdited: true,
        }));
        setNominees(updatedNominees.filter((_ele: NOMINEEINFO, index: number) => index !== ind));
    };

    const handleSubmit = () => {
        try {
            setShow(false);
            handleDeleteNominee(deleteIndex);
        } catch (err: any) {
            alert(err.message);
        }
    };

    const handleUpdateNominee = async () => {
        const isNomineeUpdated = nominees.find((_ele: NOMINEEINFO) => _ele.isEdited === true);
        if (!isNomineeUpdated && !noNomineeFlag) {
            alert('Please make the necessary changes to proceed with your request');
            return;
        }
        try {
            setLoading(true);
            let nomineePayload = null;
            if (!noNomineeFlag) {
                const totalShare = nominees
                    .map((_ele: NOMINEEINFO) => _ele.share)
                    .reduce((sum: number = 0, current) => sum + Number(current), 0);
                if (totalShare > 100) {
                    throw Error(dashboard.UpdateNominee.NoteModals.greaterModal);
                }
                if (totalShare < 100) {
                    throw Error(dashboard.UpdateNominee.NoteModals.lessModal);
                }
                if (nominees.length) {
                    let names: string[] = [];
                    let error = false;
                    nominees.some((nominee) => {
                        if (names.includes(nominee.name)) {
                            error = true;
                        }
                        names = [...names, nominee.name];
                        return false;
                    });
                    if (error) throw Error('Nominees name should be different from each other');
                }
                // if (
                //     !nominees[0].name ||
                //     !nominees[0].dob ||
                //     !nominees[0].share ||
                //     !nominees[0].relation ||
                //     !nominees[0].gender
                // ) {
                //     throw Error('Nominee Details cannot be empty');
                // }
                nomineePayload = nominees.map((_ele: NOMINEEINFO, ind: number) => ({
                    nominee: ind + 1,
                    name: _ele.name,
                    percent: _ele.share,
                    gender: _ele.gender,
                    dob: getDateString(_ele.dob),
                    pan: _ele.pan,
                    address1: _ele.address1,
                    address2: _ele.address2,
                    address3: _ele.address3 || '',
                    city: _ele.city,
                    state: _ele.state,
                    pincode: _ele.pincode,
                    country: _ele.country,
                    relation: _ele.relation,
                    guardian: {
                        name: _ele.guardianName,
                        pan: _ele.guardianPan,
                        pekrn: '',
                        dob: _ele.guardianDob,
                    },
                }));
            }
            const { pan = '', pekrn = '', mobile = '' } = props;
            // let res = await props.sendPhoneOTP({
            //     mobile,
            //     pan,
            //     pekrn,
            //     action: OTP_ACTIONS.updateNominee,
            // });
            const nomineeApiPayload = {
                folio: nomineesData.id,
                amc: nomineesData.amc,
                noNominee: noNomineeFlag ? 'Y' : '',
                nominees: noNomineeFlag ? [] : nomineePayload,
                eNomType: 'F',
                eSignFlag: '',
                eNomDocId: '',
            };
            props.history.replace('minor-status-list', {
                // mobile: props.mobile,
                newPan: props.location.state.newPan,
                targetFunds: props.location.state.targetFunds,
                nomineeData: [nomineeApiPayload],
                // ...(res || {}).body,
            });
        } catch (e: any) {
            setShowShareModal({ show: true, text: e.message });
            // alert(e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.UpdateNominee.UpdateNomineeHeading} />
            <div className="curved-bg-content curved-bg-table-outer update-nominee-screen">
                <div className="curved-bg-content-table">
                    {/* <h5> {dashboard.UpdateNominee.UpdateNomineeInfo}</h5> */}
                    <div className="curved-table-content update-nominee">
                        {nominees.every((_ele: NOMINEEINFO) => !_ele.isEditable) && (
                            <div style={{ marginTop: '15px' }}>
                                <CheckBoxField
                                    onChange={(e) => setNoNomineeFlag(!noNomineeFlag)}
                                    value={noNomineeFlag}
                                    label={dbCommercial.profileDetails.nominees.noNominee}
                                />
                            </div>
                        )}
                        {!noNomineeFlag &&
                            nominees.map((_ele: NOMINEEINFO, index: number) =>
                                !_ele.isEditable ? (
                                    <div className="nominee-list">
                                        <div className="nominee-list-single">
                                            <div className="nominee_name">
                                                <span>
                                                    <img src="/images/family-icon.svg" alt="icon" />
                                                </span>
                                                {getNameIndex(index + 1)}{' '}
                                                {dashboard.UpdateNominee.nomineeText}
                                                <div className="nominee_detail_edit mobile_mode">
                                                    <img
                                                        src="/images/edit.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            setNominees(
                                                                (prevState: NOMINEEINFO[]) => {
                                                                    const nominees = [...prevState];
                                                                    const {
                                                                        initialState,
                                                                        ...nominee
                                                                    } = nominees[index];
                                                                    nominees[index].initialState =
                                                                        nominee;
                                                                    nominees[index].isEditable =
                                                                        true;
                                                                    return nominees;
                                                                },
                                                            );
                                                        }}
                                                    />
                                                    {nominees.length > 1 && (
                                                        <img
                                                            src="/images/delete_nominee.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                setShow(true);
                                                                setDeleteIndex(index);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            <div className="nominee-detail-right">
                                                <div className="nominee-detail-top">
                                                    <div className="nominee_detail">
                                                        <p className="label">
                                                            {' '}
                                                            {dashboard.UpdateNominee.name}
                                                        </p>
                                                        <p className="value">{_ele.name} </p>
                                                    </div>
                                                    <div className="nominee_detail nominee_detail_relation">
                                                        <p className="label">
                                                            {dashboard.UpdateNominee.relation}
                                                        </p>
                                                        <p className="value">
                                                            {_ele.relation
                                                                .slice(0, 1)
                                                                .toUpperCase() +
                                                                _ele.relation.slice(1)}
                                                        </p>
                                                    </div>
                                                    <div className="nominee_detail nominee_detail_share">
                                                        {!_ele.editShare ? (
                                                            <>
                                                                <p className="label">
                                                                    {dashboard.UpdateNominee.share}
                                                                </p>
                                                                <p className="value">
                                                                    {_ele.share}%
                                                                    <img
                                                                        src="/images/edit.svg"
                                                                        alt="icon"
                                                                        onClick={() =>
                                                                            handleNomineeChange(
                                                                                'editShare',
                                                                                true,
                                                                                index,
                                                                            )
                                                                        }
                                                                    />
                                                                </p>
                                                            </>
                                                        ) : (
                                                            <div className="nominee_detail_share_edit">
                                                                <TextInput
                                                                    label="%(share)"
                                                                    variant="outlined"
                                                                    value={_ele.share}
                                                                    onBlur={(e) => {
                                                                        if (
                                                                            Number(
                                                                                e.target.value,
                                                                            ) === 0
                                                                        ) {
                                                                            alert(
                                                                                'Nominee share should not be 0',
                                                                            );
                                                                            return;
                                                                        }
                                                                        handleNomineeChange(
                                                                            'editShare',
                                                                            false,
                                                                            index,
                                                                        );
                                                                        handleNomineeChange(
                                                                            'isEdited',
                                                                            true,
                                                                            index,
                                                                        );
                                                                    }}
                                                                    onChange={(e) => {
                                                                        Number(e.target.value) <=
                                                                        100
                                                                            ? handleNomineeChange(
                                                                                  'share',
                                                                                  e.target.value,
                                                                                  index,
                                                                              )
                                                                            : null;
                                                                    }}
                                                                />
                                                                <img
                                                                    src="/images/tick-green.svg"
                                                                    alt="icon"
                                                                    onClick={() => {
                                                                        handleNomineeChange(
                                                                            'editShare',
                                                                            false,
                                                                            index,
                                                                        );
                                                                        handleNomineeChange(
                                                                            'isEdited',
                                                                            true,
                                                                            index,
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="nominee_detail_more">
                                                        {!_ele.showDetails ? (
                                                            <a
                                                                // href="#"
                                                                onClick={() =>
                                                                    handleNomineeChange(
                                                                        'showDetails',
                                                                        true,
                                                                        index,
                                                                    )
                                                                }
                                                            >
                                                                {dashboard.UpdateNominee.more}
                                                                <img
                                                                    src="/images/down-arrow-purple.svg"
                                                                    alt="icon"
                                                                />
                                                            </a>
                                                        ) : (
                                                            <a
                                                                // href="#"
                                                                onClick={() =>
                                                                    handleNomineeChange(
                                                                        'showDetails',
                                                                        false,
                                                                        index,
                                                                    )
                                                                }
                                                            >
                                                                {dashboard.UpdateNominee.less}
                                                                <img
                                                                    src="/images/up-arrow-purple.svg"
                                                                    alt="icon"
                                                                />
                                                            </a>
                                                        )}
                                                    </div>
                                                    <div className="nominee_detail_edit desktop_mode">
                                                        <img
                                                            src="/images/edit.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                setNominees(
                                                                    (prevState: NOMINEEINFO[]) => {
                                                                        const nominees = [
                                                                            ...prevState,
                                                                        ];
                                                                        const {
                                                                            initialState,
                                                                            ...nominee
                                                                        } = nominees[index];
                                                                        nominees[
                                                                            index
                                                                        ].initialState = nominee;
                                                                        nominees[index].isEditable =
                                                                            true;
                                                                        return nominees;
                                                                    },
                                                                );
                                                            }}
                                                        />
                                                        {nominees.length > 1 && (
                                                            <img
                                                                src="/images/delete_nominee.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    setShow(true);
                                                                    setDeleteIndex(index);
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                {_ele.showDetails && (
                                                    <div className="nominee-detail-bottom">
                                                        <div className="nominee_detail nominee_detail_gender">
                                                            <p className="label">
                                                                {' '}
                                                                {dashboard.UpdateNominee.gender}
                                                            </p>
                                                            <p className="value">
                                                                {_ele.gender
                                                                    .slice(0, 1)
                                                                    .toUpperCase() +
                                                                    _ele.gender.slice(1)}
                                                            </p>
                                                        </div>
                                                        <div className="nominee_detail nominee_detail_address">
                                                            <p className="label">
                                                                {' '}
                                                                {dashboard.UpdateNominee.address}
                                                            </p>
                                                            <p className="value">{_ele.address1}</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <AddNominee
                                        initialValues={_ele}
                                        index={index + 1}
                                        handleAddNominee={handleAddNomiee}
                                        handleResetForm={(ind: number) => resetForm(ind)}
                                        handleNomineeChange={(
                                            key: string,
                                            value: any,
                                            ind: number,
                                        ) => handleNomineeChange(key, value, ind)}
                                        saveNominee={(key: string, value: any, ind: number) => {
                                            const nominee = [...nominees];
                                            nominee[ind] = {
                                                ...nominee[ind],
                                                isEditable: false,
                                                isNewlyAdded: false,
                                                isEdited: true,
                                            };
                                            setNominees(nominee);
                                        }}
                                        nominees={nominees}
                                        investorName={investorName}
                                        relations={
                                            _ele.relation
                                                ? relationShips.filter((relation: RELATIONS) => {
                                                      const addedRelations = nominees
                                                          .map((nominee: NOMINEEINFO) => {
                                                              if (
                                                                  nominee.relation !== _ele.relation
                                                              )
                                                                  return nominee.relation;
                                                          })
                                                          .filter((ele) => ele);
                                                      return !addedRelations.includes(
                                                          relation.label,
                                                      );
                                                  })
                                                : relationShips.filter((relation: RELATIONS) => {
                                                      const addedRelations = nominees.map(
                                                          (_ele: NOMINEEINFO) => _ele.relation,
                                                      );
                                                      return !addedRelations.includes(
                                                          relation.label,
                                                      );
                                                  })
                                        }
                                        pan={props.pan}
                                        cancelFormSubmission={cancelFormSubmission}
                                    />
                                ),
                            )}
                        {nominees.length < 3 && !noNomineeFlag && (
                            <div className="add-nominee-btn">
                                <a onClick={() => handleAddNomiee()}>
                                    + {dashboard.UpdateNominee.addNominee}
                                </a>
                            </div>
                        )}
                        <FaqLink section={UPDATE_NOMINEE} history={props.history} />
                        {nominees.every(
                            (_ele: NOMINEEINFO) => !_ele.isEditable && !_ele.editShare,
                        ) && (
                            <div className="curved-bg-content-inner-bottom">
                                <SubmitButtonWithLoader
                                    type="submit"
                                    loading={loading}
                                    labelWhileLoading={"Submitting"}
                                    className="customBtn"
                                    label={'Submit'}
                                    onClick={handleUpdateNominee}
                                />
                            </div>
                        )}
                        <NoteModals
                            showModal={show}
                            info={dashboard.UpdateNominee.NoteModals.deleteNominee}
                            proceedBtn={dashboard.noteModals.otpModal.proceedText}
                            cancelBtn={dashboard.noteModals.otpModal.cancelText}
                            onProceed={handleSubmit}
                            onCancel={() => setShow(false)}
                        />
                        <NoteModals
                            showModal={showShareModal.show}
                            info={showShareModal.text}
                            proceedBtn={dashboard.UpdateNominee.NoteModals.okay}
                            extraClass="share-modal"
                            onProceed={() =>
                                setShowShareModal({
                                    show: false,
                                    text: '',
                                })
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { sendPhoneOTP },
)(MinorUpdateNomineeEdit);
